<template>
<div class="chapter">
<div class="inner_page">
<p class="SP" id="ch8"> </p>
<p class="CN">*</p>
<p class="CO"><span class="ePub-SC">I REMEMBER MR INBELICATE TAKING HOLD</span> of that papier-mâché snuffbox, and that a chip of paint came away in his overflow of enthusiasm.</p>
<p class="TX">‘Robert Seymour might well have become a minor cleric had it not been for Dr Syntax,’ he said, as his fingernail tapped the box upon the shelf, next to the family Bible. ‘But, one day, his brother purchased an issue of the <span class="ePub-I">Poetical Magazine</span> and left it on the table at home.’ Where once the goldfish jar had stood. ‘Young Robert picked it up, turned the pages – and was instantly captivated by the illustration of <span class="ePub-I">Dr Syntax Pursued by a Bull.</span> Here was this bony old bore scrambling up a tree to escape the bull’s horns – hat and wig carried away on the wind, bald head exposed to public ridicule. “This is rather wonderful,” thought young Seymour.’</p>
<p class="TX">‘Yet to me this young Seymour sounds a very earnest boy,’ I said, ‘with a strong religious impulse, and sermonising tendencies. I would say he had much in common with Dr Syntax.’</p>
<p class="TXS">‘Exactly, Scripty! And every time he joined in with the general laughter at Syntax, he laughed himself a little away from the church.’ Until eventually there came a day when he missed his appointment at St Mary’s pulpit. There was more enjoyment to be found in the print shops.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter8.vue?8779ba52